import { useTranslation } from "react-i18next";
import {
  AutoComplete,
  AutoCompleteMulti,
  FormContainer,
  FormEmojiTextInput,
  FormInput,
  ISelectType,
  Treturn,
  useFetch,
} from "@4uhub/lib4uhub";
import { useCallback, useEffect, useMemo, useState } from "react";
import { Grid } from "@mui/material";
import { listMainGenerics } from "../../../../../../../services/generic.service";
import {
  createTicketAutomationReceivedConfFile,
  getTicketAutomationReceivedConfFileById,
  updateTicketAutomationReceivedConfFileById,
} from "../../../../../../../services/ticketAutomationReceivedConfFiles.service";
import {
  automationReceivedConfFileSchema,
  TAutomationReceivedConfFileForm,
} from "./automationReceivedConfFileSchema";
import { calendarRegisterList } from "../../../../../../../services/ticketAutomationReceivedSlotCalendar.service";
import { IAutomationReceivedConfFileProps } from "./models";
import { calendarPreferenceExternalList } from "../../../../../../../services/calendarPreferenceExternal.service";
import { insuranceRegisterList } from "../../../../../../../services/ticketAutomationReceivedRuleInsurance.service";
import { getInsuranceTypesList } from "../../../../../../../services/tasyInsuranceType.service";
import { FilesInternalProcedure } from "./FilesInternalProcedure/FilesInternalProcedure";

const translationPath =
  "chatBot.page.automations.automationReceivedRules.automationReceivedConfFile.";

const AutomationReceivedConfFile = ({
  id,
  ticketAutomationReceivedRuleId,
  onBackButton,
  automationCode,
}: IAutomationReceivedConfFileProps) => {
  const { t } = useTranslation();

  const { sendRequest: save, loading: sLoading } = useFetch(
    createTicketAutomationReceivedConfFile,
  );

  const { sendRequest: update, loading: uLoading } = useFetch(
    updateTicketAutomationReceivedConfFileById,
  );

  const { sendRequest: get, loading: gLoading } = useFetch(
    getTicketAutomationReceivedConfFileById,
  );

  const [
    optionsTicketAutomationReceivedConfFileCalePreferences,
    setTicketAutomationReceivedConfFileCalePreferences,
  ] = useState<ISelectType[]>([]);

  const [
    optionsTicketAutomationReceivedConfFileCalendars,
    setTicketAutomationReceivedConfFileCalendars,
  ] = useState<ISelectType[]>([]);

  const [
    optionsTicketAutomationReceivedConfFileCaleInsurances,
    setTicketAutomationReceivedConfFileCaleInsurances,
  ] = useState<ISelectType[]>([]);

  const [
    optionsTicketAutomationReceivedConfFileCaleInsuranceTypes,
    setTicketAutomationReceivedConfFileCaleInsuranceTypes,
  ] = useState<ISelectType[]>([]);

  const { sendRequest: preferenceRequest } = useFetch(
    calendarPreferenceExternalList,
  );

  const { sendRequest: insuranceRegisterRequest } = useFetch(
    insuranceRegisterList,
  );

  const { sendRequest: insuranceTypeRequest } = useFetch(getInsuranceTypesList);

  const { sendRequest } = useFetch(calendarRegisterList);

  const updateHandler = (v: TAutomationReceivedConfFileForm, id: string) =>
    update({
      item: {
        id: id,
        ...v,
        destinationCalendarFileId: v.destinationCalendarFile.id,
        displayOrder: Number(v.displayOrder),
        message: v.message,
        messageError: v.messageError,
        waitLimitTime: Number(v.waitLimitTime),
        ticketAutomationReceivedConfFileCalendars:
          v.ticketAutomationReceivedConfFileCalendars
            ? v.ticketAutomationReceivedConfFileCalendars.map((cal) => ({
                externalId: cal.id,
                externalName: cal.name,
              }))
            : undefined,
        ticketAutomationReceivedConfFileCalePreferences:
          v.ticketAutomationReceivedConfFileCalePreferences
            ? v.ticketAutomationReceivedConfFileCalePreferences.map((cal) => ({
                externalId: cal.id,
                externalName: cal.name,
              }))
            : undefined,
        ticketAutomationReceivedConfFileCaleProcedures:
          v.ticketAutomationReceivedConfFileCaleProcedures
            ? v.ticketAutomationReceivedConfFileCaleProcedures.map((cal) => ({
                externalId: cal.id,
                externalName: cal.name,
              }))
            : undefined,
        ticketAutomationReceivedConfFileCaleInsurances:
          v.ticketAutomationReceivedConfFileCaleInsurances
            ? v.ticketAutomationReceivedConfFileCaleInsurances.map((cal) => ({
                externalId: cal.id,
                externalName: cal.name,
              }))
            : undefined,
        ticketAutomationReceivedConfFileCaleInsuranceTypes:
          v.ticketAutomationReceivedConfFileCaleInsuranceTypes
            ? v.ticketAutomationReceivedConfFileCaleInsuranceTypes.map(
                (cal) => ({
                  externalId: cal.id,
                  externalName: cal.name,
                }),
              )
            : undefined,
        ticketAutomationReceivedRuleId: ticketAutomationReceivedRuleId ?? "",
      },
      id: id,
    });

  const saveHandler = (v: TAutomationReceivedConfFileForm) =>
    save({
      ...v,
      destinationCalendarFileId: v.destinationCalendarFile.id,
      displayOrder: Number(v.displayOrder),
      message: v.message,
      messageError: v.messageError,
      waitLimitTime: Number(v.waitLimitTime),
      ticketAutomationReceivedConfFileCalendars:
        v.ticketAutomationReceivedConfFileCalendars
          ? v.ticketAutomationReceivedConfFileCalendars.map((cal) => ({
              externalId: cal.id,
              externalName: cal.name,
            }))
          : undefined,
      ticketAutomationReceivedConfFileCalePreferences:
        v.ticketAutomationReceivedConfFileCalePreferences
          ? v.ticketAutomationReceivedConfFileCalePreferences.map((cal) => ({
              externalId: cal.id,
              externalName: cal.name,
            }))
          : undefined,
      ticketAutomationReceivedConfFileCaleProcedures:
        v.ticketAutomationReceivedConfFileCaleProcedures
          ? v.ticketAutomationReceivedConfFileCaleProcedures.map((cal) => ({
              externalId: cal.id,
              externalName: cal.name,
            }))
          : undefined,
      ticketAutomationReceivedConfFileCaleInsurances:
        v.ticketAutomationReceivedConfFileCaleInsurances
          ? v.ticketAutomationReceivedConfFileCaleInsurances.map((cal) => ({
              externalId: cal.id,
              externalName: cal.name,
            }))
          : undefined,
      ticketAutomationReceivedConfFileCaleInsuranceTypes:
        v.ticketAutomationReceivedConfFileCaleInsuranceTypes
          ? v.ticketAutomationReceivedConfFileCaleInsuranceTypes.map((cal) => ({
              externalId: cal.id,
              externalName: cal.name,
            }))
          : undefined,
      ticketAutomationReceivedRuleId: ticketAutomationReceivedRuleId ?? "",
    });

  const getHandler = useCallback(
    async (id: string): Promise<Treturn<TAutomationReceivedConfFileForm>> => {
      const { data, success } = await get(id);

      if (data) {
        const newData: TAutomationReceivedConfFileForm = {
          ...data,
          destinationCalendarFile: {
            id: data.destinationCalendarFile.id,
            name: data.destinationCalendarFile.name,
          },
          displayOrder: data.displayOrder.toString(),
          message: data.message,
          messageError: data.messageError,
          waitLimitTime: data.waitLimitTime?.toString(),
          ticketAutomationReceivedConfFileCalendars:
            data.ticketAutomationReceivedConfFileCalendars
              ? data.ticketAutomationReceivedConfFileCalendars.map((cal) => ({
                  id: cal.externalId,
                  name: cal.externalName,
                }))
              : undefined,
          ticketAutomationReceivedConfFileCaleProcedures:
            data.ticketAutomationReceivedConfFileCaleProcedures
              ? data.ticketAutomationReceivedConfFileCaleProcedures.map(
                  (cal) => ({
                    id: cal.externalId,
                    name: cal.externalName,
                  }),
                )
              : undefined,
          ticketAutomationReceivedConfFileCalePreferences:
            data.ticketAutomationReceivedConfFileCalePreferences
              ? data.ticketAutomationReceivedConfFileCalePreferences.map(
                  (cal) => ({
                    id: cal.externalId,
                    name: cal.externalName,
                  }),
                )
              : undefined,
          ticketAutomationReceivedConfFileCaleInsurances:
            data.ticketAutomationReceivedConfFileCaleInsurances
              ? data.ticketAutomationReceivedConfFileCaleInsurances.map(
                  (cal) => ({
                    id: cal.externalId,
                    name: cal.externalName,
                  }),
                )
              : undefined,
          ticketAutomationReceivedConfFileCaleInsuranceTypes:
            data.ticketAutomationReceivedConfFileCaleInsuranceTypes
              ? data.ticketAutomationReceivedConfFileCaleInsuranceTypes.map(
                  (cal) => ({
                    id: cal.externalId,
                    name: cal.externalName,
                  }),
                )
              : undefined,
        };
        return { data: newData, success: true };
      }
      return { data, success };
    },
    [get],
  );

  const tasyScheduleTypeCode = useMemo(() => {
    if (!automationCode) return;

    switch (automationCode) {
      case "20":
        return [3];
      case "21":
        return [2];
      default:
        return null;
    }
  }, [automationCode]);
  const classificationConsultationIdentifier = useMemo(() => {
    if (!automationCode) return;

    switch (automationCode) {
      case "25":
        return ["R"];
      default:
        return null;
    }
  }, [automationCode]);

  const params = useMemo(() => {
    return {
      EnableCode: true,
      TasyScheduleTypeCode: tasyScheduleTypeCode,
      ClassificationConsultationIdentifier:
        classificationConsultationIdentifier,
    };
  }, [tasyScheduleTypeCode, classificationConsultationIdentifier]);

  const genericParams = useMemo(() => {
    return { Identifier: "DestinationCalendarFile" };
  }, []);

  const fetchTicketAutomationReceivedConfFileCalendars =
    useCallback(async () => {
      const { data, success } = await sendRequest(params);

      if (data && success) {
        const isType3Selected =
          Array.isArray(tasyScheduleTypeCode) &&
          tasyScheduleTypeCode.includes(3);

        setTicketAutomationReceivedConfFileCalendars(
          data.map((d) => {
            const titleBase = isType3Selected
              ? (d.descriptionSite ?? d.calendarName)
              : d.calendarName;

            return {
              id: String(d.identifier),
              name: `${titleBase} - ${d.identifier}`,
            };
          }),
        );
      }
    }, [sendRequest, params, tasyScheduleTypeCode]);

  useEffect(() => {
    fetchTicketAutomationReceivedConfFileCalendars();
  }, [fetchTicketAutomationReceivedConfFileCalendars]);

  const paramsPreference = useMemo(() => {
    return {
      EnableCode: true,
      TasyScheduleTypeCodeList: tasyScheduleTypeCode,
    };
  }, [tasyScheduleTypeCode]);

  const fetchTicketAutomationReceivedConfFileCalePreferences =
    useCallback(async () => {
      const { data, success } = await preferenceRequest(paramsPreference);
      if (data && success) {
        setTicketAutomationReceivedConfFileCalePreferences(
          data.map((d) => ({
            id: d.identifier.toString(),
            name: d.preference,
          })),
        );
      }
    }, [paramsPreference, preferenceRequest]);

  useEffect(() => {
    fetchTicketAutomationReceivedConfFileCalePreferences();
  }, [fetchTicketAutomationReceivedConfFileCalePreferences]);

  const paramsInsuranceRegister = useMemo(() => {
    return {
      EnableCode: true,
    };
  }, []);

  const fetchTicketAutomationReceivedConfFileCaleInsurances =
    useCallback(async () => {
      const { data, success } = await insuranceRegisterRequest(
        paramsInsuranceRegister,
      );
      if (data && success) {
        setTicketAutomationReceivedConfFileCaleInsurances(
          data.map((d) => ({
            id: d.identifier.toString(),
            name: d.insuranceName,
          })),
        );
      }
    }, [paramsInsuranceRegister, insuranceRegisterRequest]);

  useEffect(() => {
    fetchTicketAutomationReceivedConfFileCaleInsurances();
  }, [fetchTicketAutomationReceivedConfFileCaleInsurances]);

  const paramsInsuranceType = useMemo(() => {
    return {
      Identifier: 11,
    };
  }, []);

  const fetchTicketAutomationReceivedConfFileCaleInsuranceTypes =
    useCallback(async () => {
      const { data, success } = await insuranceTypeRequest(paramsInsuranceType);
      if (data && success) {
        setTicketAutomationReceivedConfFileCaleInsuranceTypes(
          data.map((d) => ({
            id: d.identifierValue,
            name: d.domainValueName,
          })),
        );
      }
    }, [paramsInsuranceType, insuranceTypeRequest]);

  useEffect(() => {
    fetchTicketAutomationReceivedConfFileCaleInsuranceTypes();
  }, [fetchTicketAutomationReceivedConfFileCaleInsuranceTypes]);

  const loading = sLoading || uLoading || gLoading;

  return (
    <FormContainer<TAutomationReceivedConfFileForm>
      saveFunction={saveHandler}
      updateFunction={updateHandler}
      getFunction={getHandler}
      loading={loading}
      title={t(translationPath + "file")}
      schema={automationReceivedConfFileSchema}
      subtitle={t(translationPath + "new_file")}
      backButtonOnClick={onBackButton}
      redirectOnSave={false}
      onSuccess={onBackButton}
      isModalForm={true}
      defaultValues={{ automationCode: automationCode }}
      propId={id}
      formActionsOnBottom={false}
      fields={() => (
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <AutoComplete
              getOptionLabel={({ name }) => name}
              size="small"
              label={t(translationPath + "destination_calendar_file")}
              name="destinationCalendarFile"
              request={listMainGenerics}
              params={genericParams}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <FormInput
              type="number"
              size="small"
              name="displayOrder"
              fullWidth
              label={t(translationPath + "display_order") || "Display Order"}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <FormInput
              type="number"
              size="small"
              name="waitLimitTime"
              fullWidth
              label={t(translationPath + "wait_limit_time")}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <AutoCompleteMulti
              params={params}
              fullWidth
              options={optionsTicketAutomationReceivedConfFileCalendars}
              name="ticketAutomationReceivedConfFileCalendars"
              label={t(
                translationPath + "ticketAutomationReceivedConfFileCalendars",
              )}
              getOptionLabel={(option) => option.name}
              size="small"
              keepOpenOnSelect={true}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <AutoCompleteMulti
              params={params}
              fullWidth
              options={optionsTicketAutomationReceivedConfFileCalePreferences}
              name="ticketAutomationReceivedConfFileCalePreferences"
              label={t(
                translationPath +
                  "ticketAutomationReceivedConfFileCalePreferences",
              )}
              getOptionLabel={(option) => option.name}
              size="small"
              keepOpenOnSelect={true}
            />
          </Grid>

          {automationCode === "21" && (
            <FilesInternalProcedure
              automationCode={automationCode}
              params={params}
            />
          )}

          <Grid item xs={12} sm={6}>
            <AutoCompleteMulti
              params={params}
              fullWidth
              options={optionsTicketAutomationReceivedConfFileCaleInsurances}
              name="ticketAutomationReceivedConfFileCaleInsurances"
              label={t(
                translationPath +
                  "ticketAutomationReceivedConfFileCaleInsurances",
              )}
              getOptionLabel={(option) => option.name}
              size="small"
              keepOpenOnSelect={true}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <AutoCompleteMulti
              params={params}
              fullWidth
              options={
                optionsTicketAutomationReceivedConfFileCaleInsuranceTypes
              }
              name="ticketAutomationReceivedConfFileCaleInsuranceTypes"
              label={t(
                translationPath +
                  "ticketAutomationReceivedConfFileCaleInsuranceTypes",
              )}
              getOptionLabel={(option) => option.name}
              size="small"
              keepOpenOnSelect={true}
            />
          </Grid>
          <Grid item xs={12}>
            <FormEmojiTextInput
              size="small"
              name="message"
              label={t(translationPath + "message") || "Message"}
              fullWidth
              multiline
              minRows={4}
            />
          </Grid>
          <Grid item xs={12}>
            <FormEmojiTextInput
              size="small"
              name="messageError"
              label={t(translationPath + "messageErro") || "Error Message"}
              fullWidth
              multiline
              minRows={4}
            />
          </Grid>
        </Grid>
      )}
    />
  );
};

export default AutomationReceivedConfFile;
